import { render, staticRenderFns } from "./FirstHome.vue?vue&type=template&id=2f0e1a4d&scoped=true&"
import script from "./FirstHome.vue?vue&type=script&lang=js&"
export * from "./FirstHome.vue?vue&type=script&lang=js&"
import style0 from "./FirstHome.vue?vue&type=style&index=0&id=2f0e1a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e1a4d",
  null
  
)

export default component.exports